import { render, staticRenderFns } from "./CollectionsPage.vue?vue&type=template&id=bf6534b0&scoped=true&"
import script from "./CollectionsPage.vue?vue&type=script&lang=js&"
export * from "./CollectionsPage.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsPage.vue?vue&type=style&index=0&id=bf6534b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6534b0",
  null
  
)

export default component.exports